export const vectorStores = Object.freeze({
    CHROMA: 'CHROMA',
    FAISS: 'FAISS',
});
